import {AnyAction} from "redux";
import {
    FETCH_ALUNO,
    FETCH_ALUNOS,
    FETCH_CLASSES, FETCH_DOF,
    FETCH_ESTRUTURA_DISCIPLINAS, POST_ALUNO, POST_ALUNO_PRE,
    RECEIVE_ALUNO,
    RECEIVE_ALUNOS, RECEIVE_CLASSES, RECEIVE_DISCOFFER_CONTENTDATES, RECEIVE_DOF,
    RECEIVE_ESTRUTURA_DISCIPLINAS,
    FETCH_PERSON_DOCUMENTS, RECEIVE_PERSON_DOCUMENTS,
    FETCH_DOCUMENT_TYPES, RECEIVE_DOCUMENT_TYPES,
    UPLOAD_PERSON_DOCUMENT, UPLOAD_PERSON_DOCUMENT_SUCCESS,
    DELETE_PERSON_DOCUMENT, DELETE_PERSON_DOCUMENT_SUCCESS

} from "../actionTypes";
import {iLevel} from "../../types/Level";
import {log} from "../../utils/log";

interface cadastrosState {
    isFetchingAlunos : boolean,
    isFetchingAluno : boolean,
    isFetchingEstrururaDisciplinas: boolean,
    isFetchingClasses: boolean,
    isFetchingDOF: boolean,
    isPostingAluno: boolean,
    alunosBase: any[]
    aluno: object,
    estruturaDisciplinas: iLevel[],
    classes: any[],
    dof: any[],
    dofAbertas: any[],
    dofContentDates: any[],
    personDocuments: iPersonDocument[],
    documentTypes: iDocumentType[],
    isFetchingDocuments: boolean,
    isFetchingDocumentTypes: boolean,
    isUploadingDocument: boolean,
    isDeletingDocument: boolean
}

const initialState : cadastrosState = {
    isFetchingAlunos : false,
    isFetchingAluno: false,
    isFetchingEstrururaDisciplinas: false,
    isFetchingClasses: false,
    isFetchingDOF: false,
    isPostingAluno: false,
    alunosBase: [],
    aluno: {},
    estruturaDisciplinas: [],
    classes: [],
    dof: [],
    dofAbertas: [],
    dofContentDates: [],
    personDocuments: [],
    documentTypes: [],
    isFetchingDocuments: false,
    isFetchingDocumentTypes: false,
    isUploadingDocument: false,
    isDeletingDocument: false
}


const cadastrosReducer = (state = initialState, action: AnyAction) => {

    switch(action.type) {

        case RECEIVE_DISCOFFER_CONTENTDATES:
            return {
                ...state,
                dofContentDates: action.payload
            }
        
        case FETCH_ALUNOS :
            return {
                ...state,
                isFetchingAlunos : true
            };

        case RECEIVE_ALUNOS :
            log(3,"reducer.cadastro.alunosBase. receive.")
            return {
                ...state,
                isFetchingAlunos : false,
                alunosBase: action.payload
            };
        
        case FETCH_ALUNO :
            return {
                ...state,
                isFetchingAluno : true,
                aluno: {}
            };
        case RECEIVE_ALUNO:
            return {
                ...state,
                isFetchingAluno : false,
                aluno: action.payload
            };
        case POST_ALUNO_PRE:
            return {
                ...state,
                isPostingAluno: true
            }
        case POST_ALUNO:
            return {
                ...state,
                isPostingAluno: false
            }
        case FETCH_ESTRUTURA_DISCIPLINAS:
            return {
                ...state,
                isFetchingEstrururaDisciplinas: true,
            }
        case RECEIVE_ESTRUTURA_DISCIPLINAS:
            return {
                ...state,
                isFetchingEstrururaDisciplinas: false,
                estruturaDisciplinas: action.payload
            }
    
        case FETCH_CLASSES:
            return {
                ...state,
                isFetchingClasses: true,
            }
        case RECEIVE_CLASSES:
            return {
                ...state,
                isFetchingClasses: false,
                classes: action.payload
            }
    
        case FETCH_DOF:
            return {
                ...state,
                isFetchingDOF: true,
            }
        case RECEIVE_DOF:
            
            const dofAbertas =  action.payload
                .filter( (d: any) => d.isEnrollmentClosed !== true)
                .filter( (d: any) => d.classOffer.isEnrollmentClosed !== true)
            
            return {
                ...state,
                isFetchingDOF: false,
                dof: action.payload,
                dofAbertas: dofAbertas
            }
            
        // Person Documents
        case FETCH_PERSON_DOCUMENTS:
            return { ...state, isFetchingDocuments: true };
        case RECEIVE_PERSON_DOCUMENTS:
            return { ...state, isFetchingDocuments: false, personDocuments: action.payload };
        case FETCH_DOCUMENT_TYPES:
            return { ...state, isFetchingDocumentTypes: true };
        case RECEIVE_DOCUMENT_TYPES:
            return { ...state, isFetchingDocumentTypes: false, documentTypes: action.payload };
        case UPLOAD_PERSON_DOCUMENT:
            return { ...state, isUploadingDocument: true };
        case UPLOAD_PERSON_DOCUMENT_SUCCESS:
            return { ...state, isUploadingDocument: false };
        case DELETE_PERSON_DOCUMENT:
            return { ...state, isDeletingDocument: true };
        case DELETE_PERSON_DOCUMENT_SUCCESS:
            return { ...state, isDeletingDocument: false };

        default:
            return state;

    }
}
export default cadastrosReducer;